import React, {Fragment, useState} from 'react';
// import uuid from 'uuid';
import { v4 as uuidv4 } from 'uuid';
import Proptypes from 'prop-types';

const Formulario = ({crearCita}) => {
  //Crear State de citas
  const [cita, actualizarCita] = useState({
    mascota: '',
    propietario: '',
    fecha: '',
    hora: '',
    sintomas: ''
  });

  const [error, actualizarError] = useState(false)

  //funcion que se ejecuta cada que el usuario escribe en un input 
  const actualizarState = e => {
    // console.log(e.target.name);
    // console.log(e.target.value);
    actualizarCita({
      ...cita, 
      [e.target.name]: e.target.value
    })
  }

  //Extraer los valores
  const {mascota, propietario, fecha, hora, sintomas} = cita;

  //cuando preciona agregar cita
  const submitCita = e => {
    // alert('Enviando')
    e.preventDefault();
    // console.log('Eviando Form')

    // Validar
    if(mascota.trim() === '' || propietario.trim() === '' || fecha.trim() === '' || hora.trim() === '' || sintomas.trim() === ''){
      actualizarError(true);
      return;
    }

    //eliminar mensaje previo
    actualizarError(false);
    // console.log('agrenando...')
    
    //Asignar un Id    
    // cita.id = 20;
    cita.id = uuidv4();
    console.log(cita);

    //Crear Cita
    crearCita(cita);

    //Reiniciar formulario
    actualizarCita({
      mascota: '',
      propietario: '',
      fecha: '',
      hora: '',
      sintomas: ''
    })


  }

  return ( 
    <Fragment>
      <h2>Crear Cita</h2>

      {error ? <p className='alerta-error'>Todos los campos son obligatorios </p> : null}

      <form
        onSubmit={submitCita}
      >
        <label>Nombre Mascota</label>
        <input 
          type="text"
          name="mascota"
          className="u-full-width"
          placeholder="Nombre Mascota"
          onChange={actualizarState}
          value={mascota}
        />
        <label>Nombre Dueño</label>
        <input 
          type="text"
          name="propietario"
          className="u-full-width"
          placeholder="Nombre Dueño de la Mascota"
          onChange={actualizarState}
          value={propietario}
        />
        <label>Fecha </label>
        <input 
          type="date"
          name="fecha"
          className="u-full-width"
          onChange={actualizarState}
          value={fecha}       
        />
        <label>Date</label>
        <input 
          type="time"
          name="hora"
          className="u-full-width"
          onChange={actualizarState}
          value={hora}      
        />
        <label>Síntomas</label>
        <textarea 
          className="u-full-width" 
          name="sintomas" 
          onChange={actualizarState}
          value={sintomas}
          ></textarea>
        
        
        <button 
          type="submit"          
          className="u-full-width button-primary"          
        >Agregar Cita </button>
      </form>
    </Fragment>
   );
}

Formulario.prototype = {
  crearCita: Proptypes.func.isRequired
}
export default Formulario;